import { FounderDashboardFrame } from './FounderDashboardFrame';

/** Home route content for `/dashboard`. Frame + Daily Brief. */
export function FounderDashboardPage() {
  return <FounderDashboardFrame />;
}
